<script>
    import axios from "axios";
    import AuthGuard from "../../../common/AuthGuard.svelte";
    import ContentSection from "../../../common/ContentSection.svelte";
    import GeneralLayout from "../../../common/GeneralLayout.svelte";
    import ChangePasswordModal from "./ChangePasswordModal.svelte";
    import ResetPasswordModal from "./ResetPasswordModal.svelte";

    $: users = [];
    $: passwordChangeModalVisible = false;
    $: passwordResetModalVisible = false;

    let currentUser = null;

    let preferences = {};
    $: smtpSender = "sender@example.com";
    $: smtpHost = "localhost";
    $: smtpPort = 567;
    $: smtpUser = "user";
    $: smtpPassword = "password";

    function getUsers() {
        console.log("getUsers");
        return axios
            .get("/api/admin/user" + "?userId=" + window.localStorage.getItem("userId"), {
                headers: {
                    Authorization:
                        "Bearer " + window.localStorage.getItem("token"),
                },
            })
            .then((response) => {
                console.log("getUsers", response.data);
                users = [response.data]
            });
    }

    function updatePreference(key, value) {
        return axios
            .put(
                "/api/admin/preferences/" + key,
                {
                    key,
                    value,
                },
                {
                    headers: {
                        Authorization:
                            "Bearer " + window.localStorage.getItem("token"),
                    },
                }
            )
            .then((response) => {
                console.log(response);
            });
    }

    function getPreferences() {
        return axios
            .get("/api/admin/preferences", {
                headers: {
                    Authorization:
                        "Bearer " + window.localStorage.getItem("token"),
                },
            })
            .then((response) => {
                console.log(response);

                preferences = response.data;

                console.log(preferences);

                smtpSender = preferences.find(
                    (p) => p.key === "smtpSender"
                ).value;
                smtpHost = preferences.find((p) => p.key === "smtpHost").value;
                smtpPort = preferences.find((p) => p.key === "smtpPort").value;
                smtpUser = preferences.find((p) => p.key === "smtpUser").value;
                smtpPassword = preferences.find(
                    (p) => p.key === "smtpPassword"
                ).value;
            });
    }

    function showPasswordChangeModal(user) {
        currentUser = user;
        passwordChangeModalVisible = true;
    }

    function showPasswordResetModal(user) {
        currentUser = user;
        passwordResetModalVisible = true;
    }

    function onCloseModal() {
        passwordChangeModalVisible = false;
        passwordResetModalVisible = false;
        currentUser = null;
    }

    function onSavePreferences() {
        updatePreference("smtpSender", smtpSender);
        updatePreference("smtpHost", smtpHost);
        updatePreference("smtpPort", smtpPort);
        updatePreference("smtpUser", smtpUser);
        updatePreference("smtpPassword", smtpPassword);
    }

    getUsers();
    getPreferences();
</script>

<AuthGuard/>

<GeneralLayout>
    <div slot="firstSegment">
        <div class="headline-l header">Einstellungen</div>
    </div>
    <div slot="secondSegment" class="content">
        <div
                class="divider-h category-divider hide-desktop"
                style="background-color: transparent;"
        />
        <div class="headline-s sub-header">Nutzer</div>
        <div class="divider-h category-divider"/>
        {#each users as user, index}
            <div class="user-section">
                <ContentSection title={user.username}>
                    <div
                            slot="content"
                            class="user-section"
                            style="margin-bottom: -32px;"
                    >
                        <div>Email: {user.email}</div>
                        <div/>
                        <button
                                type="button"
                                class="button text-l"
                                on:click={() => showPasswordChangeModal(user)}
                        >
                            Passwort ändern
                        </button>
                        <button
                                type="button"
                                class="button text-l"
                                on:click={() => showPasswordResetModal(user)}
                        >
                            Passwort zurücksetzen
                        </button>
                    </div>
                </ContentSection>
            </div>
            {#if index < users.length - 1}
                <div class="divider-h divider"/>
            {/if}
        {/each}

        <div
                class="divider-h category-divider"
                style="background-color: transparent;"
        />
        <div class="headline-s sub-header">Email</div>
        <div class="divider-h category-divider"/>

        <div class="settings-row">
            <ContentSection title="Absenderadresse">
                <div slot="content" style="margin-bottom: -16px;">
                    <input type="text" bind:value={smtpSender}/>
                </div>
            </ContentSection>
            <ContentSection title="SMTP-Host">
                <div slot="content" style="margin-bottom: -16px;">
                    <input type="text" bind:value={smtpHost}/>
                </div>
            </ContentSection>
            <ContentSection title="SMTP-Port">
                <div slot="content" style="margin-bottom: -16px;">
                    <input type="number" bind:value={smtpPort}/>
                </div>
            </ContentSection>
            <ContentSection title="SMTP-Nutzer">
                <div slot="content" style="margin-bottom: -16px;">
                    <input type="text" bind:value={smtpUser}/>
                </div>
            </ContentSection>
            <ContentSection title="SMTP-Passwort">
                <div slot="content" style="margin-bottom: -16px;">
                    <input type="password" bind:value={smtpPassword}/>
                </div>
            </ContentSection>
        </div>

        <button
                on:click={onSavePreferences}
                style="float: right; margin-right: 48px;">Speichern
        </button
        >
    </div>
</GeneralLayout>

{#if passwordChangeModalVisible}
    <ChangePasswordModal on:close={onCloseModal} user={currentUser}/>
{/if}

{#if passwordResetModalVisible}
    <ResetPasswordModal on:close={onCloseModal} user={currentUser}/>
{/if}

<style>
    .header {
        margin: 48px 16px 16px 16px;
    }

    .content {
        padding: 16px 16px;
        height: 100%;
    }

    .user-section {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: start;
        width: auto;
    }

    .category-divider {
        margin: 16px 0;
    }

    .divider {
        margin: 16px 0;
    }

    .hide-desktop {
        display: block;
    }

    .settings-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: start;
        width: auto;
    }

    @media (max-width: 1024px) {
        .settings-row {
            flex-direction: column;
        }
    }

    @media (min-width: 1440px) {
        .settings-row {
            flex-direction: column;
        }

        .hide-desktop {
            display: none;
        }

        .header {
            margin: 48px 16px 16px 0px;
        }
    }
</style>
